<template>
    <div v-if="isVisible" class="hidden xl:block bg-white border-b border-gray-200 shadow-sm sticky top-0 z-30">
        <div class="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <button @click="toggleCollapse" class="flex items-center gap-2 w-full py-6">
                <span
                    class="font-header font-bold text-4xl xl:text-5xl text-gray-900 flex items-center browse-category-title">
                    Browse by Category
                    <span :class="['chevron', collapsed ? '' : 'chevron-rotated']">&gt;</span>
                </span>
            </button>
            <transition name="fade">
                <div v-show="!collapsed">
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-2 pb-6">
                        <a href="/books?category=all"
                            :class="['block px-4 py-2 text-body font-body rounded transition-colors cursor-pointer', currentCategory === 'all' ? 'bg-accent text-white' : 'text-primary hover:bg-green-50 hover:text-accent']"
                            @click.prevent="handleCategoryClick('all')">
                            All Books
                        </a>
                        <a href="/books?category=coming-soon"
                            :class="['block px-4 py-2 text-body font-body rounded transition-colors cursor-pointer', currentCategory === 'coming-soon' ? 'bg-accent text-white' : 'text-primary hover:bg-green-50 hover:text-accent']"
                            @click.prevent="handleCategoryClick('coming-soon')">
                            Coming Soon
                        </a>
                        <a v-for="category in categories" :key="category.id" :href="`/books?category=${category.slug}`"
                            :class="['block px-4 py-2 text-body font-body rounded transition-colors cursor-pointer', currentCategory === category.slug ? 'bg-accent text-white' : 'text-primary hover:bg-green-50 hover:text-accent']"
                            @click.prevent="handleCategoryClick(category.slug)">
                            {{ category.name }}
                        </a>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'

const currentCategory = ref('all')

function updateCurrentCategory() {
    const params = new URLSearchParams(window.location.search)
    currentCategory.value = params.get('category') || 'all'
}

onMounted(() => {
    updateCurrentCategory()
    window.addEventListener('popstate', updateCurrentCategory)
    window.addEventListener('app:url-change', updateCurrentCategory)
})

onUnmounted(() => {
    window.removeEventListener('popstate', updateCurrentCategory)
    window.removeEventListener('app:url-change', updateCurrentCategory)
})

const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    categories: {
        type: Array,
        default: () => []
    },
    permanent: {
        type: Boolean,
        default: false
    }
})

const isVisible = ref(props.visible)
const collapsed = ref(true)

function toggleCollapse() {
    collapsed.value = !collapsed.value
}

watch(() => props.visible, (newVal) => {
    isVisible.value = newVal
})



function handleCategoryClick(slug) {
    currentCategory.value = slug
    // Update the URL and trigger a popstate event so BooksPage updates
    const url = `/books?category=${slug}`
    window.history.pushState({}, '', url)
    window.dispatchEvent(new CustomEvent('app:url-change', {
        detail: {
            url: window.location.href,
            category: slug
        }
    }))
    window.dispatchEvent(new PopStateEvent('popstate'))
    collapsed.value = true
}
</script>

<style scoped>
.browse-category-title {
    font-size: 1.35rem !important;
}

@media (min-width: 1280px) {
    .browse-category-title {
        font-size: 1.8rem !important;
    }
}

.chevron {
    display: inline-block;
    font-size: 1.35rem;
    font-weight: normal;
    margin-left: 1.5rem;
    transition: transform 0.2s;
    line-height: 1;
    color: var(--color-accent, #166534);
    /* fallback to Tailwind green-800 */
    font-family: Arial, Helvetica, sans-serif;
    letter-spacing: -0.1em;
    cursor: pointer;
    transform: translateY(4px);
}

@media (min-width: 1280px) {
    .chevron {
        font-size: 1.8rem;
    }
}

.chevron-rotated {
    transform: rotate(90deg);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}
</style>
